import { object } from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';
import connect from '../../helper/connect';
import FatcaV2 from './fatca-v2';
import { newFatcaCrsV2 } from '../../../form-util';

const FatcaV2QuestionType = ({ question, context }) => {
    const [subquestions, setSubquestions] = useState([]);
    const initForm = useCallback(() => {
        const currentValues = context.getValue(question.definisjon);
        let newState;
        if (currentValues.length === 0) {
            newState = newFatcaCrsV2(currentValues, true);
        } else {
            newState = currentValues;
        }
        context.onChange(question.definisjon, { value: newState });
        setSubquestions(newState);
    }, [context, question.definisjon]);

    useEffect(() => {
        if (subquestions.length === 0) {
            initForm();
        }
    }, [initForm, context, question.definisjon, subquestions.length]);

    const changeAnswer = (id, patch) => {
        const newState = [...context.getValue(question.definisjon)];
        const idx = newState.findIndex((ans) => ans.id === id);
        newState[idx] = { ...newState[idx], ...patch };
        context.onChange(question.definisjon, { value: newState });
        setSubquestions(newState);
    };

    return (
        <div className="crs-skjema">
            {subquestions &&
                subquestions.map((subquestion) => (
                    <FatcaV2
                        key={`answer_${subquestion.id}`}
                        question={subquestion}
                        onChange={changeAnswer}
                        ekstratekster={question.ekstratekster || {}}
                        prefilled={subquestion.prefilled}
                    />
                ))}
        </div>
    );
};

FatcaV2QuestionType.propTypes = {
    question: object.isRequired,
    context: object,
};

export default connect(React.memo(FatcaV2QuestionType));
